<input id="filter-by-text-input"
       type="text"
       placeholder="{{text.placeholder}}"
       [ngModel]="searchTerm.values$() | async"
       (ngModelChange)="searchTermChanged.next($event)">
